import React, { useState, useEffect } from 'react';
import { validateCSS } from './UIBuilderHelper';

interface CustomCSSInputProps {
    initialValue?: string;
    onChange?: (cssValue: string) => void;
    placeholder?: string;
    className?: string;
    showTitle?: boolean;
}


const CustomCSSInput: React.FC<CustomCSSInputProps> = ({
    initialValue = '',
    onChange,
    placeholder = 'Enter your CSS here...',
    className = '',
    showTitle = true
}) => {
    const [cssValue, setCssValue] = useState(initialValue);
    const [isFocused, setIsFocused] = useState(false);
    const [validationResult, setValidationResult] = useState<{ isValid: boolean; error?: string }>({ isValid: true });
  
    useEffect(() => {
        if (initialValue !== undefined) {
        setCssValue(initialValue);
        setValidationResult(validateCSS(initialValue));
        }
    }, [initialValue]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = e.target.value;
        setCssValue(newValue);
        

        const result = validateCSS(newValue);
        setValidationResult(result);
        
        onChange && onChange(newValue);
    };

    return (
        <div className="tw-w-full">
            {showTitle === true ? <div className={`${className} tw-text-slate-500 tw-text-sm tw-leading-none tw-ms-4 tw-me-2 tw-mt-[18px] tw-mb-[4px]`}>Custom CSS</div> : null}
            <div className={`${className} tw-flex-auto tw-flex tw-items-center tw-mx-4`}>
                <div className="tw-w-full">
                    <div 
                        className={`tw-bg-slate-50 tw-border ${
                        !validationResult.isValid 
                            ? 'tw-border-red-400' 
                            : isFocused 
                            ? 'tw-border-accent-hover tw-shadow-sm' 
                            : 'tw-border-slate-300'
                        } tw-rounded-md tw-overflow-hidden tw-transition-all tw-duration-200`}
                    >
                        <div className="tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-1 tw-bg-slate-100 tw-border-b tw-border-edge">
                            <span className="tw-text-xs tw-font-medium tw-text-slate-500">CSS</span>
                            {!validationResult.isValid && (
                                <span className="tw-text-xs tw-text-red-500 tw-font-medium">Invalid CSS</span>
                            )}
                        </div>
                        <textarea data-testid="components-customcssinput-textarea-1"
                            value={cssValue}
                            onChange={handleChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            placeholder={placeholder}
                            className="tw-w-full tw-h-64 tw-p-3 tw-font-mono tw-text-sm tw-resize-none tw-outline-none tw-bg-transparent tw-text-slate-800"
                            spellCheck="false"
                        />
                    </div>
                    
                    {!validationResult.isValid && validationResult.error && (
                        <div className="tw-mt-1 tw-text-sm tw-text-red-500 tw-px-1">
                            {validationResult.error}
                        </div>
                    )}
                    </div>
            </div>
        </div>
    );
};

export default CustomCSSInput;